import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../BackendConnections";
import {
  fetchInYourProfessionalPeerAction,
  fetchSuggestedContactsAction,
  sendProfessionConnectionAction,
  sendSuggestedConnectionAction,
} from "../../redux/actions/network/networkAction";
import HexaImage from "../utils/imgCards/HexaImage";
import Slider from "react-slick"; 
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";

export const GrowYourContacts = (props) => {
  // console.log(props);
  const [myConnectionMore, setMyConnectionMore] = useState(false);
  const [data, setData] = useState({
    is_your_professional_peer: false,
    is_suggested_contacts: false,
  });

  const [inYourProfessionalPeer, setInYourProfessionalPeer] = useState([]);
  const [suggestedContacts, setSuggestedContacts] = useState([]);
// console.log(inYourProfessionalPeer);

// arrow width
const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 // Function to handle removal of professional peer form
  const handleRemoveFormProfession = (index) => {
    const values = [...inYourProfessionalPeer];
    values.splice(index, 1);
    setInYourProfessionalPeer(values);
  };
 // Function to handle removal of suggested contact
  const handleRemoveFormSuggested = (index) => {
    const values = [...suggestedContacts];
    values.splice(index, 1);
    setSuggestedContacts(values);
  };

  // Function to handle sending connection request to professional peer
  const handleSendFormProfession = (index) => {
    const values = [...inYourProfessionalPeer];
    const receiver = values.splice(index, 1);
    setInYourProfessionalPeer(values);
    const data = {
      receiver: receiver[0]["id"],
    };
    props.sendProfessionConnection(receiver, data);
  };
// Function to handle sending connection request to suggested contact
  const handleSendFormSuggested = (index) => {
    const values = [...suggestedContacts];
    const receiver = values.splice(index, 1);
    setSuggestedContacts(values);
    const data = {
      receiver: receiver[0]["id"],
    };
    props.sendSuggestedConnection(receiver, data);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      if (
        props.inYourProfessionalPeer.length === 0 &&
        data.is_your_professional_peer === false
      ) {
        setData((prevState) => ({
          ...prevState,
          is_your_professional_peer: true,
        }));
        props.fetchInYourProfessionalPeer(props.profile.id);
      }
      if (
        props.suggestedContacts.length === 0 &&
        data.is_suggested_contacts === false
      ) {
        setData((prevState) => ({ ...prevState, is_suggested_contacts: true }));
        props.fetchSuggestedContacts(props.profile.id);
      }
    }
    if (props.inYourProfessionalPeer) {
      // console.log(props.inYourProfessionalPeer);
      setInYourProfessionalPeer(props.inYourProfessionalPeer);
    }

    if (props.suggestedContacts) {
      setSuggestedContacts(props.suggestedContacts);
    }
  }, [props]);

  const NextArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-down slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-down-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };

  const PrevArrow = ({ onClick }) => {
    return myConnectionMore ? (
      <img
        className="arrow-up slick-arrow"
        onClick={onClick}
        src="/assets/images/arrow-up-grey.svg"
        alt=""
        style={{ float: "right", cursor: "pointer" }}
      />
    ) : (
      ""
    );
  };

  const settings = {
    infinite: true,
    dots: false,
    vertical: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    slidesPerRow: 2,
    swipeToSlide: true,
    verticalSwiping: true,
    nextArrow: (
      <div onClick>
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
            // paddingTop: "5px",
            float: isMobile ? "right" : "none"
          }}
        >
          <MdOutlineKeyboardArrowDown
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
    prevArrow: (
      <div className="row" onClick>
        <div className="arrow-up"
          style={{
            display: "inline-block",
            backgroundColor: "#283270", // Background color of the circle
            borderRadius: "50%", // Makes it a circle
            // width: "40px", // Adjust the size of the circle as needed
            height: "30px", // Adjust the size of the circle as needed
            textAlign: "center",
            lineHeight: "40px", // Vertically centers the icon
           // float: "right", // Float it to the right as specified
           float: isMobile ? "none" : "right" 
           // paddingTop:'4px'
          }}
        >
          <MdOutlineKeyboardArrowUp
            color="white" // Color of the arrow icon
            size={30} // Size of the arrow icon
            cursor="pointer"
          />
        </div>
      </div>
    ),
  };


  return (
    <div className="row grow-contacts-section">
      <div className="col-12">
        <h2 className="block-title">Grow your Network</h2>
        <div className="border-box">
        <div className="row small-gutter">
  <div className="col-12">
    <div className="border-box-title">
      <label className="two-line-text-mobile">In Your Profession - Your Peers</label>
    </div>
  </div>
  {inYourProfessionalPeer.length > 6 ? (
  <Slider {...settings}>
    {inYourProfessionalPeer.map((row, index) => (
       <div className="col-sm-6 col-12 cmb-12" key={row.id}>

        <div className="connect-profile" style={{ display: "flex", alignItems: "center" }}>
          <div className="profile-thumb">
            <div className="hexagon-wrap">
              <HexaImage
                image={
                  row.profile_pic != null
                    ? IMAGEAPI + row.profile_pic
                    : "/assets/images/no-profile.png"
                }
              />
            </div>
          </div>
          <div className="profile-content">
            <div className="left-content">
              <Link to={`/user/contact/${row.id}/`}>
                <div className="name">{row.userId.username}</div>
              </Link>{" "}
              <div className="designition">
                {row.primary_jobTitle + " - " + row.company_name}
              </div>
              <div className="mutual-connection">{row.mutual_connections} mutual connections</div>
            </div>
          </div>
          <div className="right-content-profession" style={{ marginLeft: "auto" }}>
            <Link
              to=""
              onClick={() => handleSendFormProfession(index)}
              className="connect-profile-link"
            >
              Connect
            </Link>
          </div>
          <Link
            to=""
            onClick={() => handleRemoveFormProfession(index)}
            className="remove-block"
          >
            x
          </Link>
        </div>
      </div>
    ))}
  </Slider>
) : (
  <div>
    {inYourProfessionalPeer.length > 0 ? (
      inYourProfessionalPeer.map((row, index) => (
        <div className="col-sm-6 col-12 cmb-12" key={row.id}>
          <div className="connect-profile" style={{ display: "flex", alignItems: "center" }}>
            <div className="profile-thumb">
              <div className="hexagon-wrap">
                <HexaImage
                  image={
                    row.profile_pic != null
                      ? IMAGEAPI + row.profile_pic
                      : "/assets/images/no-profile.png"
                  }
                />
              </div>
            </div>
            <div className="profile-content">
              <div className="left-content">
                <Link to={`/user/contact/${row.id}/`}>
                  <div className="name">{row.userId.username}</div>
                </Link>{" "}
                <div className="designition">
                  {row.primary_jobTitle + " - " + row.company_name}
                </div>
                <div className="mutual-connection">{row.mutual_connections} mutual connections</div>
              </div>
            </div>
            <div className="right-content-profession" style={{ marginLeft: "auto" }}>
              <Link
                to=""
                onClick={() => handleSendFormProfession(index)}
                className="connect-profile-link"
              >
                Connect
              </Link>
            </div>
            <Link
              to=""
              onClick={() => handleRemoveFormProfession(index)}
              className="remove-block"
            >
              x
            </Link>
          </div>
        </div>
      ))
    ) : (
      // Message when no professional peer connections are available
      <div className="col-12">
        <p style={{ textAlign: "left", fontWeight: 600 }}>
          You have no professional peer connections.
        </p>
      </div>
    )}
  </div>
)}

</div>
        </div>
      </div>
    </div>
  );
};
// mapStateToProps function to connect the component to the Redux store
const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const inYourProfessionalPeer = state.network.inYourProfessionalPeer;
  const suggestedContacts = state.network.suggestedContacts;

  return {
    user: user,
    profile: profile,
    inYourProfessionalPeer: inYourProfessionalPeer,
    suggestedContacts: suggestedContacts,
  };
};
// mapDispatchToProps function to connect actions to the component
const mapDispatchToProps = (dispatch) => {
  return {
    fetchInYourProfessionalPeer: (profileId) =>
      dispatch(fetchInYourProfessionalPeerAction(profileId)),
    fetchSuggestedContacts: (profileId) =>
      dispatch(fetchSuggestedContactsAction(profileId)),

    sendProfessionConnection: (receiver, data) =>
      dispatch(sendProfessionConnectionAction(receiver, data)),
    sendSuggestedConnection: (receiver, data) =>
      dispatch(sendSuggestedConnectionAction(receiver, data)),
  };
};
// Connecting the component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(GrowYourContacts);
